module.exports = __webpack_public_path__ + "img/happykids-head-title-mobile.b0ee148.png";